export default __webpack_public_path__ + "static/media/Arch_Amazon-GuardDuty_32.8da8a684.svg";